import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPost } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import parseError from "../../../utils/parseError";

export const useCreatePost = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createPostMutate, isPending: isCreating } = useMutation({
        mutationFn: createPost,
        onSuccess: (res) => {
            toast.success(res.message || "Post created successfully");
            queryClient.invalidateQueries(["posts"]);
            navigate("/blog/posts");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create post");
        },
    });

    return { createPostMutate, isCreating };
};
